import { onMaintenance, isUserAuthenticated } from '../util';

const SurveyPreview = () => import(/* webpackChunkName: "pages" */ '@/pages/surveys/SurveysFullPreview');
const SurveyLayout = () => import(/* webpackPrefetch: true */ '@/layout/surveys');
const SurveyResponse = () => import(/* webpackChunkName: "surveys" */ '@/pages/surveys/externalViews/SurveyResponse');
const SurveyEnd = () => import(/* webpackChunkName: "surveys" */ '@/pages/surveys/externalViews/SurveyEnd');
const SurveyClosed = () => import(/* webpackChunkName: "surveys" */ '@/pages/surveys/externalViews/SurveyClosed');
const SurveyDisabled = () => import(/* webpackChunkName: "surveys" */ '@/pages/surveys/externalViews/SurveyDisabled');
export default [
// Route for the full survey preview. Added here since it doesn't use the main layout
  {
    path: '/targetingtools/surveys/preview',
    name: 'Targeting tools / Surveys / Preview',
    component: SurveyPreview,
    beforeEnter: (to, from, next) => {
      if (onMaintenance()) next('/maintenance');
      else if (!isUserAuthenticated()) next('/login');
      else next();
    },
  },
  {
    path: '/survey',
    name: 'survey',
    component: SurveyLayout,
    children: [
      {
        path: '/survey/response/:c?',
        name: 'Survey Response',
        component: SurveyResponse,
      },
      {
        path: '/survey/end',
        name: 'Survey End',
        component: SurveyEnd,
      },
      {
        path: '/survey/closed',
        name: 'Survey Closed',
        component: SurveyClosed,
      },
      {
        path: '/survey/disabled',
        name: 'Survey Disabled',
        component: SurveyDisabled,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (onMaintenance()) next('/maintenance');
      else next();
    },
  },
];
